const airAdditionalFeeOptions = [
    "Pickup Selling Rate",
    "Delivery Selling Rate",
    "THC – Destination",
    "Port / Terminal Service Fees",
    "ISPS / Security Surcharge",
    "Wharfage / Port Dues",
    "Congestion Surcharge (Destination)",
    "D/O Fee (Delivery Order)",
    "Documentation Fee",
    "Manifest Amendment / Correction Fee",
    "Telex / Express Release Fee",
    "B/L Endorsement / Switch B/L Fee",
    "Late Payment / Bank Handling Fee",
    "Demurrage",
    "Detention",
    "Storage / Yard Storage",
    "Customs Clearance Service Fee",
    "Customs Inspection Fee",
    "X-Ray / Scanning Fee",
    "Sampling / Laboratory Fee",
    "Bonded Warehouse Handling",
    "Quarantine / Veterinary / Phytosanitary Fee",
    "Trucking / Drayage",
    "Chassis Fee",
    "Appointment / Waiting Time",
    "Weighbridge / Scale Fee",
    "Extra Stops / Redelivery",
    "Container Cleaning",
    "Repair / Damage Fee",
    "Seal Fee",
    "OOG Handling / Lashing",
    "DG (IMDG) Handling",
    "Reefer Plug-in / Monitoring",
    "CFS Handling (Destination)",
    "Deconsolidation Fee",
    "Warehouse Storage",
    "Piece Count / Sorting Fee",
    "Last-Mile Delivery Surcharge",
    "Courier / Express Mail Fee",
    "Certificate / Attestation Fee",
    "Insurance (Cargo / All Risk)",
    "Translation / Notary Fee",
    "T1 Fee",
    "T2 Fee",
    "Origin THC",
    "Terminal / Port Service Charge",
    "ISPS / Port Security Fee",
    "VGM (Verified Gross Mass)",
    "Weighbridge / Re-weigh",
    "Port Congestion Surcharge (Origin)",
    "Storage / Ardiye",
    "Shift / Reposition",
    "Terminal Extra Handling",
    "B/L Issue Fee",
    "Telex / Express Release",
    "Manifest / Export Declaration Filing",
    "AMS / ENS / ACI Filing",
    "B/L Amendment",
    "Switch B/L",
    "Split B/L",
    "Late Documentation Fee",
    "Late SI Fee",
    "No-Show / Cancellation Fee",
    "Roll-over / Re-booking Fee",
    "Reefer Monitoring Fee",
    "Detention (Export)",
    "Demurrage (Export)",
    "Container Inspection / Survey",
    "Chassis Waiting",
    "Waiting / Stand-by",
    "Extra KM / Route Deviation",
    "Multiple Pick-up",
    "Night / Weekend / Holiday Surcharge",
    "Empty Container Repositioning",
    "Truck Cancellation / Dry Run",
    "Drop & Pick / Swap Body",
    "Toll / Bridge / Permit Fee",
    "OOG Handling Surcharge",
    "Heavy Weight Surcharge",
    "DG (IMDG) Surcharge",
    "Reefer PTI",
    "Reefer Plug-in / Electricity",
    "Fumigation / Ventilation",
    "Escort / Permit / Route Survey",
    "Transit Declaration Processing Fee",
    "Guarantee / Bond Cost",
    "Customs Broker Extra Service Fee",
    "Declaration Amendment / Cancellation",
    "Temporary Storage / Bonded Warehouse",
    "Inspection / X-Ray / Sampling",
    "Customs Seal / Resealing",
    "Administrative Penalties",
    "Border Terminal Service Fee",
    "Gate / Barrier Fee",
    "Waiting / Queue Charge",
    "Appointment / Priority Fee",
    "Disinfection / Sanitary Control",
    "Escort / Convoy Fee",
    "Driver Permit / Visa Cost",
    "Toll / Bridge / Tunnel",
    "Road User / Vignette Fee",
    "Permit Cost (CEMT / Bilateral)",
    "Weighbridge / Overweight Fine",
    "OOG / Heavy Haul Permit",
    "Pilot Car / Traffic Escort",
    "Fuel Surcharge",
    "ADR Surcharge",
    "Cold Chain Surcharge",
    "Terminal Handling Difference",
    "Gate-in / Gate-out Fee",
    "CFS Handling",
    "Weighing / VGM Fee",
    "Crane / Forklift Charge",
    "Storage / Warehousing",
    "Demurrage / Detention",
    "Empty Return Charge",
    "Rail Terminal Handling",
    "Wagon / Slot Reservation",
    "Rail Delay / Parking",
    "Rail Waybill Fee",
    "Equipment Reposition",
    "Gauge Change / Transshipment",
    "BL / Waybill Amendment",
    "Courier Cost",
    "Legalization / Apostille",
    "Insurance Certificate Fee",
    "LOI / Guarantee Letter Cost",
    "Additional Risk Insurance",
    "Security Seal / GPS Monitoring",
    "High-Value Cargo Security",
    "Damage Survey / Expert Fee",
    "Address Change / Rerouting",
    "Failed Delivery / Re-delivery",
    "Waiting Time",
    "Extra Pickup / Drop",
    "Split Shipment",
    "Return Shipment",
    "Weekend / Overtime Operation",
    "Force Majeure Impact",
    "Technology Fee",
];

export default airAdditionalFeeOptions;